import { useEffect } from "react";

/**
 * Ouvre un champ du formulaire au montage (ex : rouvrir le moteur avec la cabine active,
 * depuis un lien externe). Le champ cible doit exposer `.focus()` (react-select) ou `.open()`
 * (drawer mobile) sur son ref.
 *
 * On attend une frame avant d'ouvrir : react-select fige son option focusée à l'ouverture et ne
 * la resynchronise jamais avec la valeur, donc ouvrir trop tôt fige un correctif en cours
 * (ex: CabinFallbackCorrection) sur l'ancienne valeur.
 *
 * @param {object} selectRefs - Map { fieldId → ref } des champs.
 * @param {string} [initialFocusField] - Id du champ à ouvrir au montage.
 */
const useInitialFocusField = (selectRefs, initialFocusField) => {
	useEffect(() => {
		if (!initialFocusField) {
			return undefined;
		}

		const frameId = requestAnimationFrame(() => {
			const field = selectRefs[initialFocusField]?.current;

			if (!field) {
				return;
			}

			if (typeof field.open === "function") {
				field.open();
			} else if (typeof field.focus === "function") {
				field.focus();
			}
		});

		return () => cancelAnimationFrame(frameId);
	}, [initialFocusField, selectRefs]);
};

export default useInitialFocusField;
